import React from "react";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import _ from "lodash";

const ChatEditIcon = (props) => {
    const {
        msg,
        onClick
    } = props;
    if (msg.status === "PENDING_SEND" && !_.toLower(msg.role).includes('contact')) {
        return <EditOutlinedIcon
            sx={{
                fontSize: 16, marginLeft: 0.5, marginTop: 1.5, color: "#b658ff",
                '&:hover': {
                    color: 'blue',    // Change color on hover
                    transform: 'scale(1.2)', // Scale the icon on hover
                }
            }}

            onClick={() => onClick(msg)}
        />;
    } else {
        return null;
    }

}
export default ChatEditIcon;
